import React from 'react';
import { Create } from 'react-admin';

import AccionForm from '../AccionForm';

function AccionCreate(props) {
  return (
    <Create {...props}>
      <AccionForm />
    </Create>
  );
}

export default AccionCreate;
